/**
 * Код вставки виджета на сайт — один на всю систему.
 *
 * Строится в двух местах: админка показывает его продавцу, а сервер отдаёт
 * внешней платформе при заведении чата на её витрине. Раньше это были две
 * разные строки, и обе не работали: админка давала относительный адрес
 * (на чужом сайте он указывает на сам этот сайт), сервер — атрибут
 * `data-inbx-key`, которого виджет не понимает.
 *
 * `publicOrigin` — адрес, по которому снаружи доступен наш сервер
 * (загрузчик отдаётся с `/static/…` без префикса `/api`).
 */
export function widgetLoaderUrl(publicOrigin: string, workspaceId: string): string {
  return `${publicOrigin.replace(/\/+$/, '')}/static/${workspaceId}/loader.js`;
}

export function widgetSnippet(
  publicOrigin: string,
  workspaceId: string,
  widgetPublicKey: string,
): string {
  return `<script async src="${widgetLoaderUrl(publicOrigin, workspaceId)}" data-widget="${widgetPublicKey}"></script>`;
}
